<p class="m-0 leading-20 text-15 white-color">{{ message }}</p>
